export const ENDPOINTS = Object.freeze({
    customerInfo: '/olb-common/customer-info',
    environmentSettings: '/olb-common/environment-settings'
});
